export enum Role {
  MD = 3,
  CA = 6,
  MA = 7,
  ENGINEER = 8,
  NP = 9,
  SUPPORT = 10,
}
